"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _shades = require("./shades");
Object.keys(_shades).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _shades[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _shades[key];
    }
  });
});
//# sourceMappingURL=index.js.map